module.exports = __webpack_public_path__ + "img/ch-protection.6ca9c855.jpg";